export default __webpack_public_path__ + "static/media/certik-logo.436990ad.svg";